import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { flattenDeep } from 'lodash';
import { MapContainer, TileLayer, useMap } from 'react-leaflet';
import { Modal, Radio } from 'antd';
import ReactEcharts from '../../../../Dashboard/ChartComponents/Echarts/Echarts';

import 'leaflet/dist/leaflet.css';
import './map.css';

import {
  getLiveCraneCountsList,
  getLiveCranesList,
  getTreeData,
  getCraneDetailsByCode
} from './apicalls';

import LeftSidePanel from './LeftSidePanel';
import MarkerCluster from './MarkerCluster';
import  StyledTable  from '../../../../../commons/styles/table';

const ComponentResize = () => {
  const map = useMap();
  useEffect(() => {
    setTimeout(() => map.invalidateSize(), 100);
  }, [map]);
  return null;
};

const MapWithClustering = () => {
  const [defaultCenter, setDefaultCenter] = useState([25.360933, 55.375195]);
  const [defaultZoom, setDefaultZoom] = useState(2);
  const [, setSelectedRow] = useState({});
  const [showMarkModal, setShowMarkModal] = useState(false);
  const [lastUpdatedTime, setLastUpdatedTime] = useState(moment().format('YYYY-MM-DD HH:mm:ss'));
  const [selectedAsset, setSelectedAsset] = useState('All');
  const [selectedMode, setSelectedMode] = useState('All');
  const [assetList] = useState(['ITV', 'RSS', 'ECH', 'MHCS1', 'QCS1', 'QCS2', 'RTGS1', 'RTGS2', 'All']);
  const [statusList] = useState(['Running', 'StandBy', 'Idle', 'All']);
  const [, setTreeData] = useState([]);
  const [selectedArea] = useState(['0-0']);
  const [getCountsList, setGetCountsList] = useState([]);
  const [, setExpandKey] = useState(null);
  const [markerList, setMarkerList] = useState([]);
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [modalDetails, setModalDetails] = useState([]);
  const [option, setOption] = useState({
    series: [
      {
        type: 'gauge',
        axisLine: {
          lineStyle: {
            width: 30,
            color: [
              [0.3, 'green'],
              [0.7, 'steelblue'],
              [1, '#fd666d']
            ]
          }
        },
        pointer: {
          itemStyle: {
            color: 'auto'
          }
        },
        axisTick: {
          distance: -30,
          length: 8,
          lineStyle: {
            color: '#fff',
            width: 2
          }
        },
        splitLine: {
          distance: -30,
          length: 30,
          lineStyle: {
            color: '#fff',
            width: 4
          }
        },
        axisLabel: {
          color: 'inherit',
          distance: 40,
          fontSize: 10
        },
        detail: {
          valueAnimation: true,
          fontSize: 10,
          formatter: '{value} km/h',
          color: 'inherit'
        },
        data: [
          {
            value: 0,
            name: 'Vehicle Speed'
          }
        ]
      }
    ]
  });

  let timeTicket = useRef(null);

  useEffect(() => {
    if (timeTicket) {
      clearInterval(timeTicket);
    }
    addMarkers(selectedAsset, selectedMode, selectedArea);
    assetHierarchy();
    timeTicket = setInterval(() => {
      addMarkers(selectedAsset, selectedMode, selectedArea);
    }, 60000);

    return () => {
      clearInterval(timeTicket);
    };
  }, []);

  const addMarkers = 
    async (asset, mode, area) => {
      try {
        let  markerList = await getLiveCranesList(asset, mode, area);
        const countsList = await getLiveCraneCountsList();
        const newMarkers = markerList.map((mark) => ({
          title: mark.Asset,
          value: mark.DeviceAlias,
          status: mark.Operating_Stage,
          position: {
            lat: mark.Latitude || '',
            lng: mark.Longitude || ''
          },
          asset: mark.Asset
        }));

        setMarkerList(newMarkers);
        setGetCountsList(countsList);
        setLastUpdatedTime(moment().format('YYYY-MM-DD HH:mm:ss'));
      } catch (error) {
        console.error('Error fetching markers:', error);
      }
    };
  const assetHierarchy = async () => {
    const treeData = await getTreeData();
    const expandKey = await getAllKeys(treeData);
    setTreeData(treeData);
    setExpandKey(expandKey);
  };

  const getAllKeys = (data) => {
    const nestedKeys = data.map((node) => {
      let childKeys = [];
      if (node.children) {
        childKeys = getAllKeys(node.children);
      }
      return [childKeys, node.key];
    });
    return flattenDeep(nestedKeys);
  };

  const onCraneClick = async (marker) => {
      const details = await getCraneDetailsByCode(marker.value);
//       const details ={
//   "Load/Unloading Status": "Loading",
//   "Engine ON time": 8,
//   "Engine OFF time": 9,
//   "Vehicle Number QC1": "NR43NQ3300",
//   "Vehicle  Operator Name": "Kumar Raj",
//   "Vehicle Speed": 12,
//   "Operating Stage QC1": "Idle"
// }
      const updatedOption = { ...option };
      updatedOption.series[0].data[0].value = details['Vehicle Speed'] || 0;
      setSelectedMarker(marker);
      setModalDetails(details);
      setOption(updatedOption);
      setShowMarkModal(true);
  };

  const columns = [
    { title: 'Asset', dataIndex: 'Asset', key: 'Asset' },
    { title: 'Total', dataIndex: 'Total', key: 'Total' },
    { title: 'Running', dataIndex: 'Running', key: 'Running' },
    { title: 'Idle', dataIndex: 'Idle', key: 'Idle' },
    { title: 'StandBy', dataIndex: 'StandBy', key: 'StandBy' },
    { title: 'Stopped', dataIndex: 'Stopped', key: 'Stopped' }
  ];
  console.log(modalDetails,"rendeerrrrrrr");
  

  return (
    <div className="AppMap">
      <div className="sidebarLeft">
        <LeftSidePanel />
      </div>

      <div className="map-container">
        <MapContainer
          center={defaultCenter} zoom={defaultZoom}
          scrollWheelZoom={true}
          style={{ width: '100%', height: '100%' }}
        >
          <ComponentResize />
          <TileLayer
            attribution='&copy; OpenStreetMap contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <MarkerCluster markers={markerList} parentCallback={onCraneClick} />
        </MapContainer>
      </div>

      <div className="sidebar">
        <div style={{ marginBottom: '10px' }}>Last Updated Time: {lastUpdatedTime}</div>

        <div>
          <span>Select Asset: </span>
          <Radio.Group
            onChange={(e) => {
              setSelectedAsset(e.target.value);
              addMarkers(e.target.value, selectedMode, selectedArea);
            }}
            value={selectedAsset}
            style={{ marginTop: 16 }}
          >
            {assetList.map((asset) => (
              <Radio.Button key={asset} value={asset}>
                {asset}
              </Radio.Button>
            ))}
          </Radio.Group>
        </div>

        <div style={{ marginTop: '10px' }}>
          <span>Select Status: </span>
          <Radio.Group
            onChange={(e) => {
              setSelectedMode(e.target.value);
              addMarkers(selectedAsset, e.target.value, selectedArea);
            }}
            value={selectedMode}
            style={{ marginTop: 16 }}
          >
            {statusList.map((status) => (
              <Radio.Button key={status} value={status}>
                {status}
              </Radio.Button>
            ))}
          </Radio.Group>
        </div>

        <StyledTable
          size="small"
          columns={columns}
          dataSource={getCountsList}
          pagination={false}
          scroll={{ y: 800 }}
          style={{ margin: '5px', marginTop: 16 }}
          onRow={(record) => ({
            onClick: () => {
              setSelectedRow(record);
              if (record.defaultLatLng) setDefaultCenter(record.defaultLatLng);
              if (record.defaultZoom) setDefaultZoom(record.defaultZoom);
            }
          })}
        />
          {selectedMarker &&
          Object.keys(selectedMarker) &&
          Object.keys(selectedMarker).length > 0 ? (
            <div style={{ textAlign: 'center', marginBottom: '10px' }}>
              {selectedMarker && selectedMarker.title ? selectedMarker.title : ''}
              <div>
                <ReactEcharts id={Math.ceil(Math.random(100, 100000) * 1000)} option={option} />
              </div>
              <div>
                Internal Terminal Vehicle
                <div>
                  {[
                    {
                      key: 'Engine On Time',
                      value:
                        modalDetails && modalDetails['Engine ON time']
                          ? modalDetails['Engine ON time']
                          : ''
                    },
                    {
                      key: 'Engine OFF Time',
                      value:
                        modalDetails && modalDetails['Engine OFF time']
                          ? modalDetails['Engine OFF time']
                          : ''
                    }
                  ].map((data, index) => {
                    return (
                      <div key={index} style={{ margin: '5px'}}>
                        <span style={{ fontWeight: 'bold', marginRight: '19px' }}>{data.key}:</span>
                        <span>{data.value}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          ) : null}
      </div>
         
        <Modal
          title={`Asset: ${selectedMarker?.title || 'Selected Crane'}`}
          open={showMarkModal}
          footer={null}
          onCancel={() => setShowMarkModal(false)}
        >
        {modalDetails && modalDetails.length > 0
          ? modalDetails.map((item, index) => (
            <div key={index}>
              {Object.keys(item).map((key) => (
                <div key={key} style={{ margin: '5px' }}>
                  <strong style={{ marginRight: '10px' }}>{key}:</strong>
                  <span>{item[key]}</span>
                </div>
              ))}
            </div>
          ))
          : null}
      </Modal>
    </div>
  );
};

export default MapWithClustering;
